import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function addBlogPost(entity, entityId, title, text, contentType, accessLevel, isDraft) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/AddBlogPost',
      data: sanitizePostData({ entity, entityId, title, text, contentType, accessLevel, isDraft }),
    });
    return data;
}

async function addComment(parentId, text) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/AddComment',
      data: sanitizePostData({parentId, text }),
    });
    return data;
}

async function updateBlogPost(id, title, text, accessLevel, isDraft) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/UpdateBlogPost',
      data: sanitizePostData({ id, title, text, accessLevel, isDraft }),
    });
    return data;
}

async function updateComment(id, text) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/UpdateComment',
      data: sanitizePostData({ id, text }),
    });
    return data;
}

async function deleteBlogPost(id) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/DeleteBlogPost',
      data: sanitizePostData({ id }),
    });
    return data;
}

async function deleteComment(id) {
    const { data } = await apiClient({
      method: 'post',
      url: '/api/Blog/DeleteComment',
      data: sanitizePostData({ id }),
    });
    return data;
}

async function getBlogPosts( entity, entityId, accessLevel, before, after, skip, limit) {

    const { data } = await apiClient({
      method: 'get',
      url: '/api/Blog/GetBlogPosts',
      params: { 
        Entity: entity,
        EntityId: entityId,
        accessLevel: accessLevel,
        before: before,
        after: after,
        skip: skip,
        limit: limit,
        },
      isAuthCheckSkipped: true,
    });

    return data;
}

async function getComments( parentId, skip, limit ) {

    const { data } = await apiClient({
      method: 'get',
      url: '/api/Blog/GetComments',
      params: { PostId: parentId, skip, limit },
      isAuthCheckSkipped: true,
    });

    return data;
}

export {
    addBlogPost,
    updateBlogPost,
    deleteBlogPost,
    getBlogPosts,
    addComment,
    updateComment,
    deleteComment,
    getComments,
}